import React from "react";
import { onBold } from "./commands";

import Icon from "./Icon";
import b from "./images/bold-b.png";
import w from "./images/bold-w.png";
import { CommandProps } from "./types";

export default function Bold({ enabled, enableDarkTheme }: CommandProps) {
    return (
        <Icon
            src={enableDarkTheme ? b : w}
            onClick={enabled ? onBold : undefined}
        />
    );
}
